/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Five_KkInputs */

const cs_enum_five_kk = /** @type {(inputs: Enum_Five_KkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5+kk`)
};

const en_enum_five_kk = /** @type {(inputs: Enum_Five_KkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5+kk`)
};

/**
* | output |
* | --- |
* | "5+kk" |
*
* @param {Enum_Five_KkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_five_kk = /** @type {((inputs?: Enum_Five_KkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Five_KkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_five_kk(inputs)
	return cs_enum_five_kk(inputs)
});